import array from "lodash/array";
import { Children, Component } from "react";

/*
 * Wrapper component to animate React components with a single root child
 *
 * ReactTransitionGroup wraps all its children in a <span> (or a custom
 * component). This is because any React component has to return a single root
 * element. By using this helper component, we completely avoid wrapping it in a
 * <span> or any other DOM component.
 * The wrapped component should have a single child root element. If it has more
 * than one, all child elements will be discarded except the first one.
 *
 * So, instead of:
 * <span class="transition-enter transition-enter-active">
 *     <div class="my-component"></div>
 * </span>
 *
 * We'll get:
 * <div class="my-component transition-enter transition-enter-active"></div>
 *
 * Usage:
 * import ReactTransitionGroup from "react-addons-css-transition-group";
 * import SingleChildAnimation from "./utils/SingleChildAnimation";
 * import MyComponent from "./MyComponent";
 *
 * <ReactTransitionGroup component={SingleChildAnimation}>
 *     {condition ? <MyComponent /> : null}
 * </ReactTransitionGroup>
 *
 * See: https://facebook.github.io/react/docs/animation.html#rendering-a-single-child
 */

class SingleChildAnimation extends Component {
    render() {
        const children = Children.toArray(this.props.children);

        return array.first(children) || null;
    }
}

export default SingleChildAnimation;
